import React, { useState } from "react";
import {
  Dropdown,
  DropdownButton,
  Modal,
  Button,
  Spinner,
} from "react-bootstrap";

const EditDeleteButton = ({ onRename, onDelete }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false); // State to track deletion progress

  const handleSelect = (eventKey) => {
    if (eventKey === "1") {
      onRename();
    } else if (eventKey === "2") {
      setShowDeleteModal(true);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setIsDeleting(false); // Reset deletion state when modal is closed
  };

  const handleConfirmDelete = async () => {
    try {
      setIsDeleting(true); // Show spinner
      await onDelete(); // Ensure the onDelete function is properly invoked
      setShowDeleteModal(false); // Close the modal after successful deletion
    } catch (error) {
      console.error("Failed to delete knowledge base:", error);
    } finally {
      setIsDeleting(false); // Hide spinner
    }
  };

  return (
    <>
      <DropdownButton
        variant="bg-white"
        id="dropdown-edit-del-button"
        title={
          <span className="d-flex align-items-center fw-bold">
            <img
              src="../assets/more-horizontal.svg"
              alt="Knowledge Base"
              className="img-fluid"
            />
          </span>
        }
        onSelect={handleSelect}
        className="upload-edit-del-dropdown"
      >
        <Dropdown.Item eventKey="1" className="fw-bold gray-color pb-3">
          <img
            src="../assets/edit-2.svg"
            alt="Knowledge Base"
            className="me-2"
          />
          Rename
        </Dropdown.Item>
        <Dropdown.Item eventKey="2" className="fw-bold gray-color">
          <img
            src="../assets/trash-1.svg"
            alt="Knowledge Base"
            className="me-2"
          />
          Delete
        </Dropdown.Item>
      </DropdownButton>

      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-three">Delete Knowledge Base</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center py-4">
            <p>
              Are you sure you want to delete this file? This action cannot be
              undone.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="none"
            className="fw-bold btn btn-light"
            onClick={handleCloseDeleteModal}
            disabled={isDeleting} // Disable cancel button while deleting
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className="ms-2 fw-bold text-white btn btn-none"
            onClick={handleConfirmDelete}
            disabled={isDeleting} // Disable delete button while deleting
          >
            {isDeleting ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditDeleteButton;
